module.exports = __webpack_public_path__ + "img/gravier_bordeaux.fb656cf9.jpg";